/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateCampaignScheduleMutationRequest,
  UpdateCampaignScheduleMutationResponse,
  UpdateCampaignSchedulePathParams,
  UpdateCampaignSchedule400,
} from '../types/UpdateCampaignSchedule'

function getUpdateCampaignScheduleUrl({
  campaign_id,
}: {
  campaign_id: UpdateCampaignSchedulePathParams['campaign_id']
}) {
  const res = {
    method: 'PUT',
    url: `/api/v1/emailbison/campaigns/${campaign_id}/schedule/` as const,
  }
  return res
}

/**
 * @description Create or update campaign schedule.
 * Request body (all fields optional):
 * monday: bool - Whether to send on Mondays
 * tuesday: bool - Whether to send on Tuesdays
 * wednesday: bool - Whether to send on Wednesdays
 * thursday: bool - Whether to send on Thursdays
 * friday: bool - Whether to send on Fridays
 * saturday: bool - Whether to send on Saturdays
 * sunday: bool - Whether to send on Sundays
 * start_time: string - Start time (HH:MM or HH:MM:SS)
 * end_time: string - End time (HH:MM or HH:MM:SS)
 * timezone: string - Timezone (e.g., "America/New_York")
 * @summary Create or update campaign schedule
 * {@link /api/v1/emailbison/campaigns/:campaign_id/schedule/}
 */
export async function updateCampaignSchedule(
  {
    campaign_id,
  }: { campaign_id: UpdateCampaignSchedulePathParams['campaign_id'] },
  data?: UpdateCampaignScheduleMutationRequest,
  config: Partial<RequestConfig<UpdateCampaignScheduleMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateCampaignScheduleMutationResponse,
    ResponseErrorConfig<UpdateCampaignSchedule400>,
    UpdateCampaignScheduleMutationRequest
  >({
    method: 'PUT',
    url: getUpdateCampaignScheduleUrl({ campaign_id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
